"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cliDefaults = void 0;
const cli_options_1 = require("./cli-options");
exports.cliDefaults = {
    server: cli_options_1.CliOptions
};
//# sourceMappingURL=cli-defaults.js.map